import isChromatic from 'chromatic';

export enum EnvironmentTier {
  DEV,
  STG,
  PREPROD,
  SBX,
  PROD,
}

const devHosts = [
  'host.docker.internal',
  'cdn.zuora.com',
  'localhost',
  'staging2-demo.zuora.com',
];

const stgHosts = [
  'one.stg.na.zuora.com',
  'staging2.zuora.com',
  'experiences-staging2.zuora.com',
  'staging.zephr.com',
];

const preprodHosts = [
  'one.preprod.zuora.com',
  'preprod.zuora.com',
  'console.preprod.zephr.com',
];

const sbxHosts = [
  'apisandbox.zuora.com',
  'one-apisandbox.zuora.com',
  'one-sandbox.zuora.com',
  'sandbox.na.zuora.com',
  'sandbox.eu.zuora.com',
  'test.zuora.com',
  'test.ap.zuora.com',
  'test.eu.zuora.com',
  'sandbox.ap.zuora.com',
  'experiences.apisandbox.zuora.com',
  'experiences.sandbox.na.zuora.com',
  'experiences.sandbox.eu.zuora.com',
  'experiences.test.zuora.com',
  'experiences.test.eu.zuora.com',
  'experiences.test.ap.zuora.com',
  'console.sandbox.zephr.com',
];

export const getEnvironmentTier = (
  hostname = window.location.hostname,
): EnvironmentTier => {
  const isHostMatch = (hostnames: string[]) => hostnames.includes(hostname);
  const isExactOrSubdomainOf = (baseHost: string) =>
    hostname === baseHost || hostname.endsWith(`.${baseHost}`);

  const isEnverIP = hostname.startsWith('10.252');
  const isEnverHostname = hostname.includes('dev.na2.zuora.com');

  // chromatic hostnames are randomly generated
  if (isHostMatch(devHosts) || isChromatic() || isEnverIP || isEnverHostname) {
    return EnvironmentTier.DEV;
  }

  if (isHostMatch(stgHosts) || isExactOrSubdomainOf('pr.staging.zephr.com')) {
    return EnvironmentTier.STG;
  }

  if (isHostMatch(preprodHosts)) {
    return EnvironmentTier.PREPROD;
  }

  if (isHostMatch(sbxHosts)) {
    return EnvironmentTier.SBX;
  }

  // default to production for unknown hosts
  return EnvironmentTier.PROD;
};

/** Maps EnvironmentTier to Amplitude spec enum (production | staging | sandbox). */
export type AmplitudeEnvironment = 'production' | 'staging' | 'sandbox';

export const getAmplitudeEnvironment = (
  tier: EnvironmentTier = getEnvironmentTier(),
): AmplitudeEnvironment => {
  switch (tier) {
    case EnvironmentTier.PROD:
      return 'production';
    case EnvironmentTier.SBX:
      return 'sandbox';
    case EnvironmentTier.STG:
    case EnvironmentTier.PREPROD:
    case EnvironmentTier.DEV:
    default:
      return 'staging';
  }
};
